/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * The status of a prize draw entry winner.
 */
export type PrizeDrawEntryWinnerStatus =
  (typeof PrizeDrawEntryWinnerStatus)[keyof typeof PrizeDrawEntryWinnerStatus]

export const PrizeDrawEntryWinnerStatus = {
  SELECTED: "SELECTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  REWARDED: "REWARDED",
} as const
